import React, { useState } from 'react';
import { chronusStore } from '../../../../../chronusStore';
import { useDispatch, useSelector } from '../../../../../chronusStore/helper';
import { eventsListingActions } from '../../../../../chronusStore/slice/eventsListing';
import i18n from '../../../../../utils/ChrI18n';
import { reject } from '../../../../../utils/CoreExtensions/ObjectExtensions';
import MonthViewFullCalendar from '../../../../generic/MonthViewFullCalendar/index';
import ChronusApi from '../../../../../services/ChronusApi';
import { renderEventContent } from './viewRenderHelper';
import Filters from './Filters';
import ListView from './ListView';
import QuickView from './QuickView';
import PageActions from './PageActions';
import InfoBanner from '../../../../generic/Utils/InfoBanner';

const TabContents = props => {
  const isCalendarView = useSelector(state => state.eventsListing.isCalendarView);
  const filters = useSelector(state => state.eventsListing.filters);
  const reRenderCounter = useSelector(state => state.eventsListing.reRenderTabContentCounter);
  const infoDetails = props.tabKeyInfoDetailsMap[props.tabKey];
  const dispatch = useDispatch();
  const [showInfoDetails, setShowInfoDetails] = useState(infoDetails !== undefined);

  const setQuickViewEventId = eventId => {
    if(props.view.showQuickViewOnClick)
      dispatch(eventsListingActions.setQuickViewEventId(eventId));
  };

  const dismissibleFn = () => {
    if(infoDetails.oneTimeFlagsPath) {
      ChronusApi.postUrlJSON(
        infoDetails.oneTimeFlagsPath, { message_tag: infoDetails.tag }
      ).then(_response => {
        setShowInfoDetails(false);
      }).catch(_error => {
        ChronusValidator.ErrorManager.ShowPageFlash(false, i18n.t("common_text.error_msg.something_went_wrong"));
      });
    }
  };

  return(
    <div key={ reRenderCounter } className={ isCalendarView ? "cui-events-calendar-view" : "" }>
      {
        chronusStore.getState().eventsListing.currentTab === props.tabKey && <>
          <Filters
            view={ props.view }
            filterData={ props.tabKeyFilterDataMap[props.tabKey] }
          >
            { props.pageActions && <PageActions pageActions={ props.pageActions } /> }
          </Filters>

          {
            showInfoDetails && <div className='mb-4'>
              <InfoBanner message={ infoDetails.text } dismissibleFn={ dismissibleFn }/>
            </div>
          }

          {
            isCalendarView ?
              <>
                <MonthViewFullCalendar
                  loadingText={ i18n.t("feature.events.content.fetching_events") }
                  eventsFetchUrl={ props.eventsFetchUrl }
                  additionalEventsFetchParams={ { ...reject(filters, "tab"), ...{ view: props.view.calendar, currentTab: props.tabKey } }  }
                  eventRendererFn={ eventInfo => renderEventContent(eventInfo, props.rsvpStatusMap) }
                  todayButtonTooltip={ props.todayButtonTooltip }
                  handleEventClick={ eventInfo => setQuickViewEventId(eventInfo.event.id) }
                  timeZone={ props.calendarTimeZone }
                  initialDate={ props.initialDate }
                >
                  {
                    calendarAttrs => <QuickView
                      fetchUrl={ props.eventDetailsUrl }
                      unSetQuickViewEventId={ () => dispatch(eventsListingActions.setQuickViewEventId()) }
                      calendarAttrs={ calendarAttrs }
                    />
                  }
                </MonthViewFullCalendar>
              </> :
              <>
                <QuickView
                  fetchUrl={ props.eventDetailsUrl }
                  unSetQuickViewEventId={ () => dispatch(eventsListingActions.setQuickViewEventId()) }
                />
                <ListView
                  eventsFetchUrl={ props.eventsFetchUrl }
                  additionalEventsFetchParams={ { view: props.view.list, currentTab: props.tabKey } }
                  showQuickViewOnClick={ props.view.showQuickViewOnClick }
                  emptyEventsContent={ props.emptyEventsContent }
                  globalEventsLink={ props.globalEventsLink }
                  applicableFilters={ Object.keys(props.tabKeyFilterDataMap[props.tabKey]) }
                />
              </>
          }
        </>
      }
    </div>
  );
}

export default TabContents;